/* @flow */
import * as React from 'react';

import * as GroupPromises from 'groups/lib/GroupPromises';
import { rootGroupCode } from 'entities/RootGroup';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export default class AnnouncementStreamDefaultView extends React.Component<{ params: Object }> {
  /* eslint-disable @remind/remind/no-on-functions */
  static async onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    const { groupCode } = nextState.params;
    const { query } = nextState.location;

    // on All Classes, /messages/stream should redirect to /messages
    // which should redirect to the first chat
    if (groupCode === rootGroupCode) {
      replaceWith({ pathname: `/classes/${groupCode}/messages`, query });
      callback();
      return;
    }

    const group = await GroupPromises.loadGroupByCode(groupCode);

    // if group doesn't exist (or user isn't in it), take them back to
    // the class they initially land on when loading Remind
    if (!group) {
      replaceWith({ pathname: `/classes`, query });
      callback();
      return;
    }

    // if group is a district, redirect
    // to /messages/stream/orgUuid
    const org = group.getOrganization();
    const orgUuid = org ? org.get('uuid') : null;
    const isDistrict = group.getType() === 'district';

    if (orgUuid && isDistrict) {
      replaceWith({ pathname: `/classes/${groupCode}/messages/stream/${orgUuid}`, query });
      callback();
      return;
    }

    // if group is not a district, redirect to /messages/stream/groupUuid
    const groupUuid = group.getUuid();
    if (groupUuid) {
      replaceWith({ pathname: `/classes/${groupCode}/messages/stream/${groupUuid}`, query });
      callback();
      return;
    }

    // in all other cases, redirect to /messages
    replaceWith({ pathname: `/classes/${groupCode}/messages`, query });
    callback();
  }

  render() {
    return null;
  }
}
